import React, { useEffect, useState } from "react"; 
import {getdevicetagsModified, maintenanceApi } from  "../../Restclient/datacollection";
import { useApiHandler } from '../../hooks/useApiHandler';
import { ErrorTypes } from '../../Restclient/axiosConfig';
import { Checkbox, Typography } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import TextField from '@mui/material/TextField';
import AssetTagsRetrievalModified from './AssetTagsRetrievalModified';
import { useSelector } from "react-redux";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CustomTableHeading from "../CommonComponents/CustomTableHeading";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CustomMultiSelectwithDefaultOptions from "../CommonComponents/CustomMultiSelectwithDefaultOptions";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import LK_Delete from "../../images/LK_Delete";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import CustomButton from "../CommonComponents/CustomButton";
import CustomTextField from "../CommonComponents/CustomTextField";
import Questionnaire from "./Questionnaire";
import PeriodicMaintenanceStandardDashboards from "./PeriodicMaintenanceStandardDashboards";

export default function PeriodicMaintenanceConfigurationParameters() {
    const [maintenancetreedata, setmaintenancetreedata] = useState([{ DefaultName:'Operation Count',TagID:'',Enable:true,Threshold:'' },{ DefaultName:'Run Hours',TagID:'',Enable:true,Threshold:'' }])
    const [devicesdata, setDevicesData] = useState([])
    const [selectedType, setSelectedType] = useState(null);
    const [maintenanceparameters, setMaintenanceParameters] = useState([{ DefaultName:'Operation Count',TagID:'',Enable:true,Threshold:'',TagType: "on" },{ DefaultName:'Run Hours',TagID:'',Enable:true,Threshold:'',TagType: "run hours" },{ DefaultName:'Trip Count',TagID:'',Enable:true,Threshold:'',TagType: "trip" }]);
    const [assetdata,setAssetData] = useState(null);
    const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] = useState(false);
    const [selectedTag, setSelectedTag] = useState({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:''});
    const [selectedAsset, setSelectedAsset] = useState({asset_name:'', device_id:''});
    const [selectedTag1, setSelectedTag1] = useState({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:''});
    const [selectedAsset1, setSelectedAsset1] = useState({asset_name:'', device_id:''});
    const [conditions, setConditions] = useState([{ TagID:'',Enable:false,Threshold:'',TagType: "state" }]); // Store conditions entered by the user
    const themechange = useSelector((state) => state.themedata.theme)
    const [tagselection, setTagSelection] = useState(false);
    const [tagindex, setTagIndex] = useState(false);
    const [tagselectionMaintenanceParameter, setTagSelectionMaintenanceParameter] = useState(false);
    const [tagindexMaintenanceParameter, setTagIndexMaintenanceParameter] = useState(false);
    const devicedetailsobject = useSelector((state) => state.mainpagedata.devicedetailsobject);
    const tagdetailsobject = useSelector((state) => state.mainpagedata.tagdetailsobject);
    const userdetails = useSelector((state) => state.logindata.userdetails)
    console.log("userdetails Periodic Maintenance",userdetails)
    const [template, setTemplate] = useState(null);
    const [clickedHandleSubmit, setClickedHandleSubmit] = useState(false);
    const [overallMaintenanceUsers, setOverallMaintenanceUsers] = useState([])
    const [overallAssignedMaintenanceUsers, setAssignedMaintenanceUsers] = useState([]) //This is User ID array
    const [overallMaintenanceUsersEmailID, setOverallMaintenanceUsersEmailID] = useState([])
    const [overallAssignedMaintenanceUsersEmailID, setAssignedMaintenanceUsersEmailID] = useState([]) 
    const [personName, setPersonName] = useState([]);
    const [personName1, setPersonName1] = useState([]);
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate)
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    const [pagesize, setPagesize] = useState(445)
    var minMaintenanceIntervalDays = 0;
    var maxMaintenanceIntervalDays =36500; //10 years
    const [errorMaintenanceIntervalDays, setErrorMaintenanceIntervalDays] = useState(false);
    var countcurrentMaintenanceDefaultConditions = [false,false];
    const [errorPredefinedMaintenanceDefaultConditions, setErrorPredefinedMaintenanceDefaultConditions] = useState(countcurrentMaintenanceDefaultConditions);
    const [errorConditionMaintenanceConditions, setErrorConditionMaintenanceConditions] = useState([false]);
    var minThresholdCBM = 0;
    var maxThresholdCBM =1000000; //10 years
    const [errorThresholdCBM, setErrorThresholdCBM] = useState(false);
    const [confirmSaveChangesDialog, setConfirmSaveChangesDialog] = useState(false);
    const [enableCBM, setEnableCBM] = useState(false);
    const [configurationSavedSuccessfully, setConfigurationSavedSuccessfully] = useState(false);
    const [openDialogconfigurationSavedSuccessfully, setopenDialogConfigurationSavedSuccessfully] = useState(false);
    const [configurationSavedMessage, setConfigurationSavedMessage] = useState('');
    const allTagTypesOC = ["state", "on","off"];
    const allTagTypesRunHours = ["run hours"];
    const allTagTypesTrip=  ["trip"];

    const mapTypes = {
        'Operation Count': allTagTypesOC,
        'Run Hours': allTagTypesRunHours,
        'Trip Count': allTagTypesTrip
    }
    //Validation dialog box
    const [opennotselectedType,setopennotselectedType] = useState(false);
    const [openconditionBasedParameters,setconditionBasedParameters] = useState(false);
    const [opendefaultParameters,setdefaultParameters] = useState(false);
    const [openuserdetailsemail,setuserdetailsemail] = useState(false);
    const [openoverallAssignedMaintenanceUsersObtained,setoverallAssignedMaintenanceUsersObtained] = useState(false);
    const [questionstemplateempty,setquestionstemplateempty] = useState(false);
    const [usersformaintenancesubmitted, setusersformaintenancesubmitted] = useState(false);
    const [openAtLeastOneConditionDialog,setopenAtLeastOneConditionDialog] = useState(false);
    const [maintabs, setMainTabs] = useState(['Device Information', 'Device Condition Based Parameters', 'Creation of SOP Template for Maintenance Tasks','Assign Maintenance Tasks']);
    const [tabvalue, setTabValue] = useState('Device Information');
    const projectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    const [createdSucess, setCreatedSuccess] = useState(false);
    const [notCreatedSuccess, setNotCreatedSuccess] = useState(false);
    const [notCreatedMessage, setNotCreatedMessage] = useState('');
    const [openDashboardDialog, setOpenDashboardDialog] = useState(false);
    const [viewDashboard, setViewDashboard] = useState(false);
    const [dashboardName, setDashboardname] = useState('')
    const[deleteDashboardObject, setDeleteDashboardObject] = useState(false);
    const [openAlertRuleNameExceedsLength, setopenAlertRuleNameExceedsLength] = useState(false);
     const[deleteMode, setDeleteMode] = useState(false);
    const [errorQuestionLength, setErrorQuestionLength] = useState(false);
    const [errorOptionLength, setErrorOptionLength] = useState(false);
     // Dialog state for condition limit
    const [openConditionLimitDialog, setOpenConditionLimitDialog] = useState(false);
    const handleOpenConditionLimitDialogClose = () => setOpenConditionLimitDialog(false);
    const handleErrorQuestionLength = () => setErrorQuestionLength(false);
    const handleErrorOptionLength = () => setErrorOptionLength(false);

    // API Handler with dialog control
    const { callApi } = useApiHandler({
        [ErrorTypes.NOT_FOUND]: 'Resource not found.',
        [ErrorTypes.FORBIDDEN]: 'You do not have permission to access this resource.',
        [ErrorTypes.SERVER_ERROR]: 'Server error occurred. Please try again.'
    });


    function handledashboardNameChange(value){
        console.log("handledashboardNameChange",value)
        setDashboardname(value)
    }

    function isValidLength(value, minLength, maxLength) {
        return value.length >= minLength && value.length <= maxLength;
    }
    function containsSpacesOrSpecialChars(str) {
        // Allow spaces and underscores, but reject other special characters
        return /[^\w\s]/.test(str);
    }

    function handleCloseUsersForMaintenanceSubmitted() {
        setusersformaintenancesubmitted(false);
      }

    const handletabchange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
            //console.log("overviewstate ", overviewstate)
            if (overviewstate) {
                setPagesize(445)
            } else {
                setPagesize(410)
            }
    }, [overviewstate])

    //Functions to handle the validation of Dialog Box
    function handleopennotselectedTypeClose(){
        setopennotselectedType(false)
    }

    function handleopenconditionBasedParametersClose(){
        setconditionBasedParameters(false)
    }

    function handleopendefaultParametersClose(){
        setdefaultParameters(false)
    }

    function handleopenuserdetailsemailClose(){
        setuserdetailsemail(false)
    }

    function handleopenoverallAssignedMaintenanceUsersObtainedClose(){
        setoverallAssignedMaintenanceUsersObtained(false)
    }

    function handleAlertRuleNameExceedsLength(){
        setopenAlertRuleNameExceedsLength(false)
    }

    function handlequestionstemplateemptyOk(){
        setquestionstemplateempty(false)
    }
    

    function handleCBMSelectionEnable(){
        setEnableCBM(!enableCBM);
    }

    const handleBlurMaintenanceIntervalDays = (event) => {
        const numValue = Number(event.target.value);
    
        // Validate if the number is within the range
        if (numValue < minMaintenanceIntervalDays || numValue > maxMaintenanceIntervalDays) {
            setErrorMaintenanceIntervalDays(true);
        }
    };
    
    function isValidThresholdCBM(value, minThresholdCBM, maxThresholdCBM){
        //console.log("isValidThresholdCBM----///////----------",value,minThresholdCBM,maxThresholdCBM,"value.length >= minThresholdCBM && value.length <= maxThresholdCBM",value.length >= minThresholdCBM && value.length <= maxThresholdCBM)
        return Number(value) >= minThresholdCBM && Number(value) <= maxThresholdCBM;
    }

    const handleSubmitTemplate = (questions) => {
        //console.log("handleSubmitTemplate questions",questions)
        setTemplate(questions);
    };

    const [deviceManufacturerName, setDeviceManufacturerName] = useState({
        manufacturername:"",
        model:"",
        serialnumber:"",
        commissiondate:""
    })
    const [maintenanceDetails, setMaintenanceDetails] = useState({
        lastmaintenanceperformeddate:Math.floor(Date.now() / 1000),
        maintenanceintervaldays:0,
        nextmaintenancedate:Math.floor(Date.now() / 1000),
        enablealertbeforedays:[]
    })

    function handledeviceManufacturer(field,value){
        if(field=='manufacturername'){
            setDeviceManufacturerName((prevValue)=>({ ...prevValue, manufacturername:value}))
        }else if(field=='model'){
            setDeviceManufacturerName((prevValue)=>({ ...prevValue, model:value}))
        }else if(field=='serialnumber'){
            setDeviceManufacturerName((prevValue)=>({ ...prevValue, serialnumber:value}))
        }else if(field=='commissiondate'){
            setDeviceManufacturerName((prevValue)=>({ ...prevValue, commissiondate:value}))
        }
    }

    function handledeviceMaintenanceDetails(field,value){
        if(field=='maintenanceintervaldays'){
            
            let num = Number(value);
            if (isNaN(num) || num < minMaintenanceIntervalDays || num > maxMaintenanceIntervalDays) {
                setErrorMaintenanceIntervalDays(true)
            }

            if( (Number(value) >= minMaintenanceIntervalDays) && (Number(value) <= maxMaintenanceIntervalDays)){
                setErrorMaintenanceIntervalDays(false)
                // Update both maintenanceintervaldays and nextmaintenancedate in a single state update
                setMaintenanceDetails((prevValue)=>{ 
                    const lastDate = Number(prevValue.lastmaintenanceperformeddate) || Math.floor(Date.now() / 1000);
                    const intervalDays = Number(value);
                    const nextDate = lastDate + (86400 * intervalDays);
                    return { 
                        ...prevValue, 
                        maintenanceintervaldays: value,
                        nextmaintenancedate: nextDate
                    };
                })
            }

           
        }
        // else if(field=='nextmaintenancedate'){
        //     setMaintenanceDetails((prevValue)=>({ ...prevValue, nextmaintenancedate:value}))
        // }else if(field=='enablealertbeforedays'){
        //     setMaintenanceDetails((prevValue)=>({ ...prevValue, enablealertbeforedays:value}))
        // }
    }

    function handleEnableAlertDays(enablealertdays){
        //console.log("handleEnableAlertDays-maintenanceDetails",maintenanceDetails)
        setMaintenanceDetails((prevValue)=>({ ...prevValue, enablealertbeforedays:enablealertdays}))
    }

    function handleAssignOverallMaintenanceUsersEmailID(emailid){
        //console.log("handleAssignOverallMaintenanceUsersEmailID-emailid",emailid)
        setAssignedMaintenanceUsersEmailID(emailid)
    }

    function handleSubmitMaintenanceTask(users){
        var overallAssignedUsersID = [];
        console.log("---overallMaintenanceUsers",overallMaintenanceUsers,"overallAssignedMaintenanceUsersEmailID",overallAssignedMaintenanceUsersEmailID)
        if(overallMaintenanceUsers != undefined && overallMaintenanceUsers != null){
            if(overallMaintenanceUsers.length > 0){
                for(var i=0;i<overallMaintenanceUsers.length;i++){
                    if(overallAssignedMaintenanceUsersEmailID != undefined && overallAssignedMaintenanceUsersEmailID != null){
                        if(overallAssignedMaintenanceUsersEmailID.length > 0){
                            for(var j=0;j<overallAssignedMaintenanceUsersEmailID.length;j++){
                                if(overallMaintenanceUsers[i].Email == overallAssignedMaintenanceUsersEmailID[j]){
                                    overallAssignedUsersID.push(overallMaintenanceUsers[i].UserID)
                                }
                            } 
                        }
                    }
                      
                }
            }
        }
        
        setusersformaintenancesubmitted(true);
        setAssignedMaintenanceUsers(overallAssignedUsersID)
    }

    //console.log("devicedetailsobject----------Periodic Maintenance Configuration Parameters",devicedetailsobject,"tagdetailsobject",tagdetailsobject)

    const getmaintenancetreedatacallback = (data) => {
        //console.log("getmaintenancetreedatacallback",data)
        setmaintenancetreedata(data.data.treeData)
    }
    
    function handlePredfinedMaintenanceParametersSelectionAddTag(index, field, value){
        var updatedmaintenanceparameters;
        if(field == 'Enable'){
            //console.log("field Enable handlePredfinedMaintenanceParametersSelection",field,value)
            updatedmaintenanceparameters = maintenanceparameters.map((condition, i) => 
                i === index ? { ...condition, [field]: !value } : condition
            );
            setMaintenanceParameters(updatedmaintenanceparameters);
        }else if(field == 'TagID'){
            //console.log("tagid-----handlePredfinedMaintenanceParametersSelectionAddTag",index,"selectedTag1",selectedTag1)
            updatedmaintenanceparameters = maintenanceparameters.map((condition, i) => 
                i === index ? { ...condition, ['TagID']: selectedTag1?.tagid} : condition
            );
            //console.log("if condition handlePredfinedMaintenanceParametersSelectionAddTagupdatedmaintenanceparameters",updatedmaintenanceparameters)
            setTagSelectionMaintenanceParameter(false)
            setMaintenanceParameters(updatedmaintenanceparameters);
        }else if(field == 'TagType'){
            updatedmaintenanceparameters = maintenanceparameters.map((condition, i) => 
                i === index ? { ...condition, ['TagType']: value} : condition
            );
            //console.log("updatedmaintenanceparameters handleChange Enable",updatedmaintenanceparameters)
            setMaintenanceParameters(updatedmaintenanceparameters);
        }else{
            updatedmaintenanceparameters = maintenanceparameters.map((condition, i) => 
                i === index ? { ...condition, [field]: value } : condition
            );
            //console.log("Predeinfed results else condition updatedmaintenanceparameters-value,minThresholdCBM,maxThresholdCBM",value,minThresholdCBM,maxThresholdCBM,"index",index,"errorPredefinedMaintenanceDefaultConditions--///",errorPredefinedMaintenanceDefaultConditions,"errorPredefinedMaintenanceDefaultConditions.length",errorPredefinedMaintenanceDefaultConditions.length)
            if((Number(value) < Number(minThresholdCBM)) || (Number(value) > Number(maxThresholdCBM))){
                
                // var currenterror = errorPredefinedMaintenanceDefaultConditions;
                // //console.log("currenterror outside handlePredfinedMaintenanceParametersSelectionAddTag123",currenterror,"index",index)
                // // if(index >= currenterror.length){
                // //     currenterror[currenterror.length-1] = true;
                // // }else{
                //     currenterror[index] = true;
                // //}
            
                // setErrorPredefinedMaintenanceDefaultConditions(currenterror)
                const newErrorArray = [...errorPredefinedMaintenanceDefaultConditions];
                newErrorArray[index] = true;
                setErrorPredefinedMaintenanceDefaultConditions(newErrorArray)
                return;
                
                
            }else{

                //console.log("updatedmaintenanceparameters---///handlePredfinedMaintenanceParametersSelectionAddTag",updatedmaintenanceparameters)
                // var currenterror = errorPredefinedMaintenanceDefaultConditions;
                // //console.log("currenterror between handlePredfinedMaintenanceParametersSelectionAddTag456",currenterror,"index",index)
                // if(index >= currenterror.length){
                //     currenterror[currenterror.length-1] = false;
                // }else{
                //     currenterror[index] = false;
                // }
                
                // setErrorPredefinedMaintenanceDefaultConditions(currenterror)
                const newErrorArray = [...errorPredefinedMaintenanceDefaultConditions];
                if(index >= newErrorArray.length){
                    newErrorArray[newErrorArray.length-1] = false;
                }else{
                    newErrorArray[index] = false;
                }
                setErrorPredefinedMaintenanceDefaultConditions(newErrorArray)
                
            }
            setMaintenanceParameters(updatedmaintenanceparameters);

            
        }

        
    }

    const fetchDevices = async () => {
        await callApi(
            () => maintenanceApi.getDevices(),
            {
                showDialog: false,
                hideDialogOnStatusCodes: [404],
                showDialogOnCatch: false,
                useBackendMessage: true,
                onSuccess: (response) => {
                    console.log("fetchDevices", response);
                    if(response.data.success && response.data.data && response.data?.data.devices){
                        setDevicesData(response.data?.data.devices);
                    }else{
                        setDevicesData([]);
                    }
                },
                onError: (error) => {
                    console.error("Error fetching devices:", error);
                    setDevicesData([]);
                },
                onCatchError: (error, errorInfo) => {
                    console.error("Unexpected error fetching devices:", error, errorInfo);
                    setDevicesData([]);
                }
            }
        );
    };

     const devicescallback = (res) => {
        if(res?.success == true){
            console.log("devicescallback",res)
            setDevicesData(res.devices)
        }else{
            setDevicesData([])
        }
         
    }

    function handleTypeSelection(typeId) {
        //console.log("handleTypeSelection-typeId",typeId)
        handledeviceManufacturer('manufacturername',devicedetailsobject[typeId]?.Make)
        handledeviceManufacturer('model',devicedetailsobject[typeId]?.Model)
        handledeviceManufacturer('serialnumber',devicedetailsobject[typeId]?.SN)
        handledeviceManufacturer('commissiondate',devicedetailsobject[typeId]?.CommissionDate)   
        setSelectedType(typeId);
    }

    const assetcallback = (res) => {
        console.log("res obtd in assetscallback in OverviewHomePage",res)
        if(res.success == true){
            setAssetData({devices: res.devices});
        }else{
            setAssetData({devices: {}});
        }
    };

    const handleAddRow = () => {
        if (conditions.length >= 10) {
            setOpenConditionLimitDialog(true);
            return;
        }
        setConditions([...conditions, { TagID:'',Enable:false,Threshold:'',TagType: "state"}]);
        //console.log("errorConditionMaintenanceConditions: handleAddRow", errorConditionMaintenanceConditions); 
        var currenterrorarray = errorConditionMaintenanceConditions;
        currenterrorarray.push(false)
        //setErrorConditionMaintenanceConditions([...errorConditionMaintenanceConditions, false]);
        setErrorConditionMaintenanceConditions(currenterrorarray)
    };

    // Remove a condition row
    const handleRemoveRow = (index) => {
        // if(conditions.length == 1 && index==0){
        //     setopenAtLeastOneConditionDialog(true)
        //     return;
        // }

        const updatedConditions = conditions.filter((_, i) => i !== index);
        setConditions(updatedConditions);

        //console.log("errorConditionMaintenanceConditions: handleRemoveRow", errorConditionMaintenanceConditions); 
        
        const filterederrorconditions = errorConditionMaintenanceConditions.filter((_, i) => i !== index)
        setErrorConditionMaintenanceConditions(filterederrorconditions);
    };

    const handleConditionChange = (index, field, value) => {
        //console.log("handleConditionChange-----",field,value)
        var updatedConditions;
        if(field == 'Enable'){
            updatedConditions = conditions.map((condition, i) => 
                i === index ? { ...condition, ['Enable']: !value} : condition
            );
            //console.log("updatedConditions handleChange Enable",updatedConditions)
            setConditions(updatedConditions);
        }
        else if(field == 'TagID'){
            updatedConditions = conditions.map((condition, i) => 
                i === index ? { ...condition, ['TagID']: selectedTag?.tagid} : condition
            );
            //console.log("selectedTag handleConditionChnage",selectedTag)
            //console.log("if condition updatedConditions",updatedConditions)
            setTagSelection(false)
            setConditions(updatedConditions);
        }else if(field == 'Threshold'){
            let num = Number(value);
            if (isNaN(num) || num < minThresholdCBM || num > maxThresholdCBM) {
                const newErrorArray = [...errorConditionMaintenanceConditions];
                newErrorArray[index] = true;
                setErrorConditionMaintenanceConditions(newErrorArray);
                // Block update if out of range
                return;
            } else {
                const newErrorArray = [...errorConditionMaintenanceConditions];
                newErrorArray[index] = false;
                setErrorConditionMaintenanceConditions(newErrorArray);
                updatedConditions = conditions.map((condition, i) => 
                    i === index ? { ...condition, [field]: num } : condition
                );
                setConditions(updatedConditions);
            }
        }else if(field == 'TagType'){
            updatedConditions = conditions.map((condition, i) => 
                i === index ? { ...condition, ['TagType']: value} : condition
            );
            //console.log("updatedConditions handleChange Enable",updatedConditions)
            setConditions(updatedConditions);
        }else{
            updatedConditions = conditions.map((condition, i) => 
                i === index ? { ...condition, [field]: value } : condition
            );
            //console.log("else condition updatedConditions",updatedConditions)
            if( (value >= minThresholdCBM) && (value <= maxThresholdCBM)){
                //console.log("updatedConditions---///handlePredfinedMaintenanceParametersSelectionAddTag",updatedConditions)
                var currenterror = errorConditionMaintenanceConditions;
                currenterror[index] = false;
                setErrorConditionMaintenanceConditions(currenterror)
            }else{
                var currenterror = errorConditionMaintenanceConditions;
                currenterror[index] = true;
                setErrorConditionMaintenanceConditions(currenterror)
            
            }
            setConditions(updatedConditions);
        } 
    }; 

    const handleTagSelectionConfirm = () => {

    }

    const handleTagSelectionClose = () => {
        setTagSelection(false)
    }

    const handleAddTag = (index) => {
        //console.log("handleAddTag----index--///////////",index)
        setTagSelection(true)
        setTagIndex(index)
    }

    const handleAddTagselectionMaintenanceParameterClose = () => {
        setTagSelectionMaintenanceParameter(false)
    }

    const handleAddTagselectionMaintenanceParameter = (index) => {
    //console.log("handleAddTagselectionMaintenanceParameter------///////////",index)
        setTagSelectionMaintenanceParameter(true)
        setTagIndexMaintenanceParameter(index)
    }

    function handleChange(event){
        //console.log("Periodic Maintenance Configuration handleChange",event)
    }

    const fetchDeviceParameters = async (deviceId) => {
        if(!deviceId) return;
        
        await callApi(
            () => maintenanceApi.getDeviceParameters(deviceId),
            {
                showDialog: false,
                hideDialogOnStatusCodes: [404],
                useBackendMessage: true,
                onSuccess: (response) => {
                    console.log("fetchDeviceParameters", response);
                    
                    const defaultParameters = [
                        { DefaultName:'Operation Count',TagID:'',Enable:true,Threshold:'',TagType: "on" },
                        { DefaultName:'Run Hours',TagID:'',Enable:true,Threshold:'',TagType: "run hours" },
                        { DefaultName:'Trip Count',TagID:'',Enable:true,Threshold:'',TagType: "trip" }
                    ];
                    
                    if(response.data.success && response.data?.data?.data?.deviceparameters){
                        const deviceParams = response.data.data.deviceparameters;
                        if(deviceParams.length > 0){
                            if((deviceParams[0]?.Default_TagID_Threshold != undefined)||(deviceParams[0]?.Assigned_TagID_Threshold != undefined)){
                                let existingParams = deviceParams[0]?.Default_TagID_Threshold || [];
                                let mergedParams = [...existingParams];
                                defaultParameters.forEach(defaultParam => {
                                    const exists = existingParams.some(param => param.DefaultName === defaultParam.DefaultName);
                                    if (!exists) {
                                        mergedParams.push(defaultParam);
                                    }
                                });
                                setMaintenanceParameters(mergedParams);
                                setConditions(deviceParams[0]?.Assigned_TagID_Threshold || []);
                            }else{
                                setMaintenanceParameters([]);
                                setConditions([]);
                            }
                        }else{
                            setMaintenanceParameters(defaultParameters);
                            setConditions([{ TagID:'',Enable:false,Threshold:'',TagType: "state" }]);
                        }
                    }else{
                        setMaintenanceParameters(defaultParameters);
                        setConditions([{ TagID:'',Enable:false,Threshold:'',TagType: "state" }]);
                    }
                },
                onError: (error) => {
                    console.error("Error fetching device parameters:", error);
                    const defaultParameters = [
                        { DefaultName:'Operation Count',TagID:'',Enable:true,Threshold:'',TagType: "on" },
                        { DefaultName:'Run Hours',TagID:'',Enable:true,Threshold:'',TagType: "run hours" },
                        { DefaultName:'Trip Count',TagID:'',Enable:true,Threshold:'',TagType: "trip" }
                    ];
                    setMaintenanceParameters(defaultParameters);
                    setConditions([{ TagID:'',Enable:false,Threshold:'',TagType: "state" }]);
                }
            }
        );
    };

    const getdevicemaintenanceparametercallback = (res) => {
        console.log("setMaintenanceParameters-res",res,"res")
        
        // Define default parameters that should always exist
        const defaultParameters = [
            { DefaultName:'Operation Count',TagID:'',Enable:true,Threshold:'',TagType: "on" },
            { DefaultName:'Run Hours',TagID:'',Enable:true,Threshold:'',TagType: "run hours" },
            { DefaultName:'Trip Count',TagID:'',Enable:true,Threshold:'',TagType: "trip" }
        ];
        
        if(res?.data?.status=="success"){
            if(res.data?.deviceparameters != undefined && res.data?.deviceparameters != null){
                if(res.data?.deviceparameters.length > 0){
                    if((res.data?.deviceparameters[0]?.Default_TagID_Threshold != undefined)||(res.data?.deviceparameters[0]?.Assigned_TagID_Threshold != undefined)){
                        // Get existing parameters
                        let existingParams = res.data?.deviceparameters[0]?.Default_TagID_Threshold || [];
                        
                        // Check for missing default parameters and add them
                        let mergedParams = [...existingParams];
                        defaultParameters.forEach(defaultParam => {
                            const exists = existingParams.some(param => param.DefaultName === defaultParam.DefaultName);
                            if (!exists) {
                                mergedParams.push(defaultParam);
                            }
                        });
                        
                        setMaintenanceParameters(mergedParams)
                        setConditions(res.data?.deviceparameters[0]?.Assigned_TagID_Threshold)
                    }else{
                        setMaintenanceParameters([])
                        setConditions([])
                    }
                }else{
                    setMaintenanceParameters(defaultParameters)
                    setConditions([{ TagID:'',Enable:false,Threshold:'',TagType: "state" }])
                }
            }    
        }else{
            setMaintenanceParameters([])
            setConditions([])
        }
        
    }

    const fetchMaintenanceUsers = async () => {
        await callApi(
            () => maintenanceApi.getUsers(),
            {
                showDialog: false,
                hideDialogOnStatusCodes: [404],
                useBackendMessage: true,
                onSuccess: (response) => {
                    console.log("fetchMaintenanceUsers", response);
                    if(response.data.success && response.data?.data?.UserDetails){
                        const users = response.data.data.UserDetails;
                        const overallUsersEmail = users.map(user => user.Email);
                        setOverallMaintenanceUsers(users);
                        setOverallMaintenanceUsersEmailID(overallUsersEmail);
                    }else{
                        setOverallMaintenanceUsers([]);
                        setOverallMaintenanceUsersEmailID([]);
                    }
                },
                onError: (error) => {
                    console.error("Error fetching maintenance users:", error);
                    setOverallMaintenanceUsers([]);
                    setOverallMaintenanceUsersEmailID([]);
                },
                onCatchError: (error, errorInfo) => {
                    console.error("Unexpected error fetching maintenance users:", error, errorInfo);
                    setOverallMaintenanceUsers([]);
                    setOverallMaintenanceUsersEmailID([]);
                }
            }
        );
    };

    const overallMaintenanceUserscallback = (res) => {
        if(res?.success == true){
            console.log("res-overallMaintenanceUserscallback",res)
            var users = res?.UserDetails;
            var overallUsersEmail = [];
            for(var i=0;i<users.length;i++){
                overallUsersEmail.push(users[i].Email)
            }
            setOverallMaintenanceUsers(users)
            setOverallMaintenanceUsersEmailID(overallUsersEmail)
        }else{
            setOverallMaintenanceUsers([])
            setOverallMaintenanceUsersEmailID([])
        }
        

    }

    function epochToIndianTimestamp(epochSeconds) {
         // Convert seconds to milliseconds for Date object 
         let wenttime = new Date(epochSeconds * 1000); 
         let wenttimeyear = wenttime.getFullYear().toString(); 
         let wenttimemonth = (wenttime.getMonth() + 1).toString().padStart(2, "0"); 
         let wenttimedaydate = wenttime.getDate().toString().padStart(2, "0"); 
         let wenttimehour = wenttime.getHours().toString().padStart(2, "0"); 
         let wenttimeminute = wenttime.getMinutes().toString().padStart(2, "0"); 
         let wenttimesec = wenttime.getSeconds().toString().padStart(2, "0"); 
         let wenttimemsec = wenttime.getMilliseconds().toString().padStart(3, "0"); // Format: YYYY-MM-DD HH:MM:SS.mmm 
         return `${wenttimeyear}-${wenttimemonth}-${wenttimedaydate} ${wenttimehour}:${wenttimeminute}:${wenttimesec}.${wenttimemsec}`; 
    }

    const saveMaintenanceDetailscallback = (res) => {
        console.log("saveMaintenanceDetailscallback",res)

        if((res.data?.data?.savedchecklistsuccess == true) && (res.data?.data?.savedconfigsuccess == true) && (res.data?.data?.savedparameterssuccess  == true)){
            setConfigurationSavedSuccessfully(true)
            setConfigurationSavedMessage("Configuration saved successfully")
            setopenDialogConfigurationSavedSuccessfully(true)
        }else{
            setConfigurationSavedSuccessfully(false)
            setConfigurationSavedMessage(res?.message || "Failed to save configuration. Please try again.")
            setopenDialogConfigurationSavedSuccessfully(true)
        }
    }

    function handlesetopenDialogConfigurationSavedSuccessfullyClose(){
        setopenDialogConfigurationSavedSuccessfully(false)
    }

    function handleViewDashboard(){
        setViewDashboard(true);
    }

    function handleCancelViewDashboard(){
        setViewDashboard(false);
    }

    function handleSaveChange() {
        var conditionBasedParameters = conditions;
        var conditionBasedParametersPresentFlag = true;
        var defaultParameters = maintenanceparameters;
        var defaultParametersPresentFlag = true;
        var maintenancedetails = maintenanceDetails;
        var userdetailsemail = userdetails;
        var userdetailsemailPresentFlag = true;
        var overallAssignedMaintenanceUsersObtained = overallAssignedMaintenanceUsers;
        var overallAssignedMaintenanceUsersObtainedPresentFlag = true;
        var questiontemplate = template;
        var questiontemplatePresentFlag = true;


        if(enableCBM == true){
            for(var i=0;i<conditionBasedParameters.length;i++){
                if(conditionBasedParameters[i].TagID == ''){
                    conditionBasedParametersPresentFlag = false;
                }
    
                if(conditionBasedParameters[i].Threshold == ''){
                    conditionBasedParametersPresentFlag = false;
                }
    
            }
    
            for(var i=0;i<defaultParameters.length;i++){
                if(defaultParameters[i].TagID == ''){
                    defaultParametersPresentFlag = false;
                }
    
                if(defaultParameters[i].Threshold == ''){
                    defaultParametersPresentFlag = false;
                }
    
            }
        }
        

        for(var i=0;i<userdetailsemail.length;i++){
            if(userdetailsemail[i].Email == ''){
                userdetailsemailPresentFlag = false;
            }
        }

        if(template == null){
            questiontemplatePresentFlag = false;
        }

        if(questiontemplate != null){
            if(overallAssignedMaintenanceUsersObtained.length == 0){
                overallAssignedMaintenanceUsersObtainedPresentFlag = false;
            }
        }

        //console.log("handleSaveChange - conditionBasedParameters",conditionBasedParameters,"defaultParameters",defaultParameters,"maintenancedetails",maintenancedetails,"userdetailsemail",userdetailsemail,"overallAssignedMaintenanceUsersObtained",overallAssignedMaintenanceUsersObtained,"questiontemplate",questiontemplate)
        //console.log("handleSaveChange - selectedType",selectedType,"userdetailsemailPresentFlag",userdetailsemailPresentFlag,"overallAssignedMaintenanceUsersObtainedPresentFlag",overallAssignedMaintenanceUsersObtainedPresentFlag,"questiontemplatePresentFlag",questiontemplatePresentFlag,"conditionBasedParametersPresentFlag",conditionBasedParametersPresentFlag,"defaultParametersPresentFlag",defaultParametersPresentFlag)
        if(selectedType == null){
            //console.log("Recahed here-1")
            setopennotselectedType(true)
            return;
        }else if(userdetailsemailPresentFlag == false){
            //console.log("Recahed here-4")
            setuserdetailsemail(true)
            return;
        }else if(overallAssignedMaintenanceUsersObtainedPresentFlag == false){
            //console.log("Recahed here-5")
            setoverallAssignedMaintenanceUsersObtained(true)
            return;
        }else if(questiontemplatePresentFlag == false){
            setquestionstemplateempty(true)
            return;
        }

        //console.log("Recahed here-1/////*********123456789")
        if(conditionBasedParametersPresentFlag == false){
            //console.log("Recahed here-2")
            if(enableCBM == true){
                setconditionBasedParameters(true)
            }
        }
        
        //console.log("Recahed here-2/////*********123456789")
        if(defaultParametersPresentFlag == false){
            //console.log("Recahed here-3-enableCBM",enableCBM,"")
            if(enableCBM == true){
                setdefaultParameters(true)
            }
        }
        //console.log("Recahed here-3/////*********123456789confirm save")
        setConfirmSaveChangesDialog(true)
        
    }

    const handleconfirmSaveChangesDialogSave = async () => {
        var nonnullconditions = conditions;
        // if(conditions != undefined){
        //     if(conditions.length > 0){
        //         nonnullconditions = conditions.filter(function (el) {
        //             return el.TagID != '';
        //         });
        //     }
        // }
        let devicename = devicedetailsobject[selectedType]?.Name;
        // console.log("handleconfirmSaveChangesDialogSave devicename",devicedetailsobject,"maintenanceDetails",maintenanceDetails)
        let modifiedMaintenanceDetails = {
            ...maintenanceDetails,
            lastmaintenanceperformeddate: maintenanceDetails.lastmaintenanceperformeddate == "" ? Math.floor(Date.now() / 1000) : maintenanceDetails.lastmaintenanceperformeddate,
        }
        var saveobject = {
            DeviceName: devicename,
            OrgID:devicedetailsobject[selectedType]?.OrgID,
            ProjectID:devicedetailsobject[selectedType]?.ProjectID,
            DeviceID: selectedType,
            MaintenanceParameter : nonnullconditions,
            MaintenanceDefaultParameter:maintenanceparameters,
            MaintenanceDetails:modifiedMaintenanceDetails,
            Maintenance_Task:{
                assigned_by_user: userdetails.Email,
                assigned_to_user: overallAssignedMaintenanceUsers,
                respondent_user_id: ''
            },
            Question_Template:template

        }
       console.log("saveobject-handleSaveChange",saveobject)
       
       await callApi(
           () => maintenanceApi.saveDetails(saveobject),
           {
               showDialog: false,
               hideDialogOnStatusCodes: [404],
               useBackendMessage: true,
               onSuccess: (response) => {
                   console.log("saveMaintenanceDetailscallback", response);
                   if(response.data.success == true){
                       setConfigurationSavedSuccessfully(true);
                       setConfigurationSavedMessage("Configuration saved successfully");
                       setopenDialogConfigurationSavedSuccessfully(true);
                   } else {
                       setConfigurationSavedSuccessfully(false);
                       setConfigurationSavedMessage(response.data.message || "Failed to save configuration. Please try again.");
                       setopenDialogConfigurationSavedSuccessfully(true);
                   }
               },
               onError: (error) => {
                   console.error("Error saving maintenance details:", error);
                   setConfigurationSavedSuccessfully(false);
                   setConfigurationSavedMessage(error.message || "Failed to save configuration. Please try again.");
                   setopenDialogConfigurationSavedSuccessfully(true);
               },onCatchError: (error, errorInfo) => {
                   console.error("Unexpected error saving maintenance details:", error, errorInfo);
                   setConfigurationSavedSuccessfully(false);
                   setConfigurationSavedMessage("Failed to save configuration due to an unexpected error. Please try again.");
                   setopenDialogConfigurationSavedSuccessfully(true);
               }
           }
       );
       
       setConfirmSaveChangesDialog(false)
    }

    function handleconfirmSaveChangesDialogClose(){
        setConfirmSaveChangesDialog(false)
    }
    
    const fetchConfig = async (deviceId) => {
        console.log("fetchConfig-deviceId",deviceId)
        if(!deviceId) return;
        
        await callApi(
            () => maintenanceApi.getConfig(deviceId),
            {
                showDialog: false,
                hideDialogOnStatusCodes: [404],
                useBackendMessage: true,
                onSuccess: (response) => {
                    console.log("fetchConfig configMaintenance", response);
                    
                    if(response.data.success && response.data?.data?.configMaintenance){
                        const configMaintenanceData = response.data.data.configMaintenance;
                        
                        let maintenanceObject = {
                            lastmaintenanceperformeddate:"",
                            maintenanceintervaldays:"",
                            nextmaintenancedate:"",
                            enablealertbeforedays:[]
                        };
                        
                        if(configMaintenanceData.length == 0){
                            maintenanceObject.lastmaintenanceperformeddate = Math.floor(Date.now() / 1000);
                            maintenanceObject.maintenanceintervaldays = 0;
                            maintenanceObject.nextmaintenancedate = Math.floor(Date.now() / 1000);
                            maintenanceObject.enablealertbeforedays = [];
                            setPersonName(maintenanceObject.enablealertbeforedays);
                        }else{
                            configMaintenanceData.sort((a, b) => new Date(a.lastmaintenanceperformeddate) - new Date(b.lastmaintenanceperformeddate));
                            const configLength = configMaintenanceData.length;
                            if(configLength > 0){
                                maintenanceObject.lastmaintenanceperformeddate = configMaintenanceData[configLength-1].lastmaintenanceperformeddate;
                                maintenanceObject.maintenanceintervaldays = configMaintenanceData[configLength-1].maintenanceintervaldays;
                                maintenanceObject.nextmaintenancedate = Number(configMaintenanceData[configLength-1].lastmaintenanceperformeddate) + (86400 * Number(configMaintenanceData[configLength-1].maintenanceintervaldays));
                                maintenanceObject.enablealertbeforedays = configMaintenanceData[configLength-1].enablealertbeforedays;
                                setPersonName(maintenanceObject.enablealertbeforedays);
                            }
                            
                            let selectedMaintenanceUsersEmailID = [];
                            let assigneddeviceusersemailID = configMaintenanceData[configLength-1].assigned_to_user;
                            if(assigneddeviceusersemailID && assigneddeviceusersemailID.length > 0){
                                for(let i=0; i<assigneddeviceusersemailID.length; i++){
                                    if(overallMaintenanceUsers && overallMaintenanceUsers.length > 0){
                                        for(let j=0; j<overallMaintenanceUsers.length; j++){
                                            if(overallMaintenanceUsers[j].UserID == assigneddeviceusersemailID[i]){
                                                selectedMaintenanceUsersEmailID.push(overallMaintenanceUsers[j].Email);
                                            }
                                        }
                                    }
                                }
                            }
                            setPersonName1(selectedMaintenanceUsersEmailID);
                        }
                        setMaintenanceDetails(maintenanceObject);
                    }else{
                        setPersonName([]);
                        setPersonName1([]);
                        setMaintenanceDetails({
                            lastmaintenanceperformeddate:Math.floor(Date.now() / 1000),
                            maintenanceintervaldays:0,
                            nextmaintenancedate:Math.floor(Date.now() / 1000),
                            enablealertbeforedays:[]
                        });
                    }
                },
                onError: (error) => {
                    console.error("Error fetching config:", error);
                    setPersonName([]);
                    setPersonName1([]);
                    setMaintenanceDetails({
                        lastmaintenanceperformeddate:"",
                        maintenanceintervaldays:"",
                        nextmaintenancedate:"",
                        enablealertbeforedays:[]
                    });
                }
            }
        );
    };

    const getconfigMaintenancecallback = (res) => {
        if(res.data.status == "success"){
            console.log("getconfigMaintenancecallback-res",res.data.configMaintenance)
            let configMaintenanceData = res.data.configMaintenance;
                    
            let maintenanceObject = {
                lastmaintenanceperformeddate:"",
                maintenanceintervaldays:"",
                nextmaintenancedate:"",
                enablealertbeforedays:[]
            }
            if(configMaintenanceData.length == 0){
                maintenanceObject.lastmaintenanceperformeddate = Math.floor(Date.now() / 1000);
                maintenanceObject.maintenanceintervaldays = 0;
                maintenanceObject.nextmaintenancedate = Math.floor(Date.now() / 1000);
                maintenanceObject.enablealertbeforedays = [];
                setPersonName( maintenanceObject.enablealertbeforedays);
            }else{
                configMaintenanceData.sort((a, b) => new Date(a.lastmaintenanceperformeddate) - new Date(b.lastmaintenanceperformeddate));
                let configMaintenanceDataLength = configMaintenanceData.length;
                if(configMaintenanceDataLength != undefined && configMaintenanceDataLength != null){
                    if(configMaintenanceDataLength > 0){
                        maintenanceObject.lastmaintenanceperformeddate = (configMaintenanceData[configMaintenanceDataLength-1].lastmaintenanceperformeddate=="" ? Math.floor(Date.now() / 1000) : configMaintenanceData[configMaintenanceDataLength-1].lastmaintenanceperformeddate);
                        maintenanceObject.maintenanceintervaldays = configMaintenanceData[configMaintenanceDataLength-1].maintenanceintervaldays;
                        maintenanceObject.nextmaintenancedate = Number(configMaintenanceData[configMaintenanceDataLength-1].lastmaintenanceperformeddate) + (86400 * Number(configMaintenanceData[configMaintenanceDataLength-1].maintenanceintervaldays));
                        maintenanceObject.enablealertbeforedays = configMaintenanceData[configMaintenanceDataLength-1].enablealertbeforedays;
                        setPersonName( maintenanceObject.enablealertbeforedays);
                    }
                }
               

                let selectedMaintenanceUsersEmailID = [];
                let assigneddeviceusersemailID = configMaintenanceData[configMaintenanceDataLength-1].assigned_to_user
                if(assigneddeviceusersemailID != undefined && assigneddeviceusersemailID !=null){
                    if(assigneddeviceusersemailID.length > 0){
                        for(var i=0;i<assigneddeviceusersemailID.length;i++){
                            if(overallMaintenanceUsers != undefined && overallMaintenanceUsers !=null){
                                if(overallMaintenanceUsers.length > 0){
                                    for(var j=0;j<overallMaintenanceUsers.length;j++){
                                        if(overallMaintenanceUsers[j].UserID == assigneddeviceusersemailID[i]){
                                            selectedMaintenanceUsersEmailID.push(overallMaintenanceUsers[j].Email)
                                        }
                                        
                                    }
                                }  
                            }
                            
                        }
                    }
                }
                
                setPersonName1(selectedMaintenanceUsersEmailID)
            }
            setMaintenanceDetails(maintenanceObject);
        }else{
            setPersonName([])
            setPersonName1([])
            setMaintenanceDetails({
                lastmaintenanceperformeddate:"",
                maintenanceintervaldays:"",
                nextmaintenancedate:"",
                enablealertbeforedays:[]
            })
        }
        
    }

    
    useEffect(()=>{
        fetchDevices();
        fetchMaintenanceUsers();
        getdevicetagsModified(assetcallback);
    },[projectname])
    
    useEffect(()=>{
        fetchDeviceParameters(selectedType);
        fetchConfig(selectedType);
    },[selectedType])

    useEffect(()=>{
    
    },[errorPredefinedMaintenanceDefaultConditions])
   
    const handleConfigureDashboard = () => {
        setOpenDashboardDialog(true);
    }

    function handleCloseCreateDashboard(){
        setCreatedSuccess(false)
    }

    function handleCloseNotCreateDashboard(){
        setNotCreatedSuccess(false)
    }

    const postpostMaintenanceDashboardCallback = (res) => {
        console.log("postpostMaintenanceDashboardCallback-res",res)
        console.log("postPQDashboardCallback",res)
        if(res.data?.success == true){
            setCreatedSuccess(true)
        }else{
            setNotCreatedMessage(res.data?.message || "Failed to create dashboard .Try Again! ");
            setNotCreatedSuccess(true)
        }
    }

    const handleSaveConfiguredDashboard = async () => {
        if (userdetails && userdetails.Projectid && userdetails.Organizationid) {

            if((!isValidLength(dashboardName,5,30)) || (containsSpacesOrSpecialChars(dashboardName))){
                setopenAlertRuleNameExceedsLength(true)
                return;
            }

            const projectIdToUse = userdetails?.Projectid == "All" ? projectname : userdetails.Projectid;
            
            await callApi(
                () => maintenanceApi.createDashboard(dashboardName, projectIdToUse),
                {
                    showDialog: false,
                    hideDialogOnStatusCodes: [404],
                    useBackendMessage: true,
                    onSuccess: (response) => {
                        console.log("postpostMaintenanceDashboardCallback", response);
                        if(response?.data?.success == true){
                            setCreatedSuccess(true);
                        } else {
                            setNotCreatedMessage(response.data?.message || "Failed to create dashboard .Try Again! ");
                            setNotCreatedSuccess(true);
                        }
                    },
                    onError: (error) => {
                        console.error("Error creating dashboard:", error);
                        setNotCreatedMessage(error.message || "Failed to create dashboard .Try Again! ");
                        setNotCreatedSuccess(true);
                    }
                }
            );
        } else {
            console.error("User details are not available or invalid.");
        }
        
        
        setOpenDashboardDialog(false);
    }
    
    const handleCloseConfigureDashboard = () => {
        setOpenDashboardDialog(false);
    }

    console.log("=== DEBUG TABLE RENDERING ===");
    console.log("selectedType:", selectedType);
    console.log("devicedetailsobject[selectedType]:", devicedetailsobject[selectedType]);
    console.log("maintenanceparameters:", maintenanceparameters);
    console.log("conditions:", conditions);
    console.log("tabvalue:", tabvalue);
    
    return (
        <>
           {(viewDashboard == false) &&  <Box className="parentDiv" style={{width: "100%",boxSizing: 'border-box'}}>
                <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"8px",textAlign:"left",marginTop:"10px"}}>Select Device to configure Scheduled and Condition Based Maintenance</Typography>
                    <Box sx={{flexGrow:1}}></Box>
                    {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
                    <div style={{marginTop:"10px", marginRight:"5px",marginBottom:"10px",}}>
                        <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                            <CustomButton /*id={assetInfo.id}*/ onClick={handleViewDashboard} buttonText={'View Dashboard'} width={'200px'} />
                            <CustomButton /*id={assetInfo.id}*/ onClick={handleConfigureDashboard} buttonText={'Configure Dashboard'} width={'200px'} />
                        </Box> 
                    </div>
                    <div style={{marginTop:"10px", marginRight:"5px",marginBottom:"10px",}}>
                        <CustomButton onClick={handleSaveChange} buttonText={'Save'} width={'12px'} />
                    </div>
                </Box>
                <div style={{ display: "flex", flexDirection:"row", width: "100%", boxSizing:"border-box", gap:"28px", }}>
                        <div style={{display:'flex', flexDirection:'column', width:"20%"}}>
                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"8px",textAlign:"left",marginTop:"0px"}}>Selected Device : <span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span>{devicedetailsobject[selectedType]?.Name}</Typography>
                            <div style={{ width:'100%',marginTop:"3px", border: "1px solid #008CD7",marginLeft:"8px",boxSizing:"border-box", overflowY:'scroll',height:`calc(100vh - ${pagesize}px)`}}>
                                <SimpleTreeView
                                    sx={{
                                    color: "var(--SecondaryText)",
                                    "& .MuiTreeItem-label .MuiTreeItem-content": {
                                        fontSize: "16px",
                                        fontWeight: 400,
                                        color: "red",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textAlign: "left", // Align labels to the left
                                    },
                                    }}
                                    defaultCollapseIcon="-"
                                    defaultExpandIcon="+"
                                >
                                    {console.log("devicesdata---render",devicesdata)}
                                    {devicesdata.map((device) => (
                                        <TreeItem key={device.id} itemId={device.DeviceID} sx={{ textAlign:'left' }} label={
                                            <FormControlLabel
                                            control={
                                                <input
                                                    type="radio"
                                                    checked={selectedType === device.DeviceID} // Controlled by the state
                                                    onChange={() => handleTypeSelection(device.DeviceID)}
                                                    />
                                            }
                                            label={device.Name}
                                            sx={{textAlign: "left",}}
                                        />
                                        } />
                                    ))}
                                </SimpleTreeView>
                            </div>
                        </div>
                        <div style={{width:"80%", display: "flex", flexDirection:"row", alignItems:"baseline",boxSizing:"border-box", marginRight:"10px"}}>
                            <Box sx={{/*width:`calc(100vw - ${1702}px)`*/ width: '100%',marginTop:"0px", height: "330px", backgroundColor: 'var(--SecondaryBackground)', borderRadius: '0px 0px 0px 0px', marginRight: '0px' }}>
                                <Box sx={{ backgroundColor: 'var(--SecondaryBackground)', }}>
                                    <Tabs
                                        value={tabvalue}
                                        onChange={handletabchange}
                                        aria-label="basic tabs example"
                                        sx={{
                                            width: 'auto',
                                            '& .MuiTabs-indicator': { display: 'none' },
                                            '& .Mui-selected': {
                                                backgroundColor: 'var(--PrimaryBackground)',
                                                borderRadius: '0px 0px 0px 0px',
                                                color: 'var(--LK_BrandBlue_1) !important',
                                                fontWeight: '700 !important',
                                                borderTop: "1px solid var(--HighlightedText_Stroke)",
                                                borderLeft: "1px solid var(--HighlightedText_Stroke)",
                                                borderRight: "1px solid var(--HighlightedText_Stroke)",
                                                borderBottom: "1px solid var(--SecondaryBackground)",
                                            },
                                            '& .MuiTab-root': {
                                                padding: '8px 8px 6px 8px !important',
                                                margin: '0px !important',
                                                minWidth: '63px',
                                            },
                                            minHeight: '30px',
                                            marginBottom: '-3px'
                                        }}>
                                        {maintabs.map((tab) => {
                                            return (
                                                <Tab
                                                sx={{
                                                    minHeight: "30px",
                                                    height: "30px",
                                                }}
                                                style={{
                                                    color: "var(--GreyVariation_2)",
                                                    fontFamily: "Roboto",
                                                    fontSize: "14px",
                                                    fontWeight: 400,
                                                    lineHeight: "16.75px",
                                                    textTransform: "capitalize",
                                                }}
                                                value={tab}
                                                label={tab}
                                                >
                                                {tab}
                                                </Tab>
                                            );
                                        })}
                                    </Tabs>
                                </Box>
                                <Box sx={{ backgroundColor: 'var(--PrimaryBackground)', width: '100%', border: "1px solid var(--HighlightedText_Stroke)", height:`calc(100vh - ${pagesize}px)`, boxSizing:'border-box' }} style={{ overflow: "auto", }}>
                                        {tabvalue == 'Device Information' && (
                                            <>
                                            <div style={{width:"100%", display: "flex", flexDirection:"row", alignItems:"baseline",boxSizing:"border-box"}}>     
                                                    <div style={{ width:"100%"}}>
                                                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop: '10px'}}>Device Information</Typography>
                                                        <div style={{ display: 'flex', flexDirection: 'row',marginTop:"3px", alignItems:"baseline", justifyContent:"space-between" }}>
                                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"10px"}}> Manufacturer's Name</Typography>
                                                            <TextField
                                                                label=""
                                                                value={deviceManufacturerName?.manufacturername}
                                                                disabled={true}
                                                                variant='standard'
                                                                type="string"
                                                                sx={{
                                                                    width: '240px',
                                                                    marginLeft:'25px',
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: '#008CD7',
                                                                    },
                                                                    "& .MuiInputBase-input.Mui-disabled": {
                                                                        color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                                                                        WebkitTextFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',// Default color
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontFamily: 'Roboto',
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                    },
                                                                    '& .MuiInput-root .MuiInputBase-input': {
                                                                        
                                                                    },
                                                                    '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#C1C1C1' : '#3C3C3C'}`
                                                                    },
                                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    '& .MuiInputBase-root::after': {
                                                                        borderBottom: '2px solid #008CD7',
                                                    
                                                                    },
                                                                }}
                                                                onChange={(e) =>
                                                                    handledeviceManufacturer('manufacturername', e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row',marginTop:"3px", alignItems:"baseline", justifyContent:"space-between" }}>
                                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Model</Typography>
                                                            <TextField
                                                                label=""
                                                                value={deviceManufacturerName?.model}
                                                                disabled={true}
                                                                variant='standard'
                                                                type="string"
                                                                sx={{
                                                                    width: '240px',
                                                                    marginLeft:'25px',
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: '#008CD7',
                                                                    },
                                                                    "& .MuiInputBase-input.Mui-disabled": {
                                                                        color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                                                                        WebkitTextFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',// Default color
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontFamily: 'Roboto',
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                    },
                                                                    '& .MuiInput-root .MuiInputBase-input': {
                                                                        
                                                                    },
                                                                    '& .MuiInputBase-root::before': {
                                                                        borderBottom: `1px solid ${themechange === 'light' ? '#C1C1C1' : '#3C3C3C'}`
                                                                    },
                                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    '& .MuiInputBase-root::after': {
                                                                        borderBottom: '2px solid #008CD7',
                                                    
                                                                    },
                                                                }}
                                                                onChange={(e) =>
                                                                    handledeviceManufacturer('model', e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row',marginTop:"3px", alignItems:"baseline", justifyContent:"space-between" }}>
                                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Serial Number</Typography>
                                                            <TextField
                                                                label=""
                                                                value={deviceManufacturerName?.serialnumber}
                                                                disabled={true}
                                                                variant='standard'
                                                                type="string"
                                                                sx={{
                                                                    width: '240px',
                                                                    marginLeft:'25px',
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: '#008CD7',
                                                                    },
                                                                    "& .MuiInputBase-input.Mui-disabled": {
                                                                        color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                                                                        WebkitTextFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',// Default color
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontFamily: 'Roboto',
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                    },
                                                                    '& .MuiInput-root .MuiInputBase-input': {
                                                                        
                                                                    },
                                                                    '& .MuiInputBase-root::before': {
                                                                        borderBottom: `1px solid ${themechange === 'light' ? '#C1C1C1' : '#3C3C3C'}`
                                                                    },
                                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    '& .MuiInputBase-root::after': {
                                                                        borderBottom: '2px solid #008CD7',
                                                    
                                                                    },
                                                                }}
                                                                onChange={(e) =>
                                                                    handledeviceManufacturer('serialnumber', e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row',marginTop:"3px", alignItems:"baseline", justifyContent:"space-between" }}>
                                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Commission Date</Typography>
                                                            <TextField
                                                                label=""
                                                                value={deviceManufacturerName?.commissiondate}
                                                                disabled={true}
                                                                variant='standard'
                                                                type="string"
                                                                sx={{
                                                                    width: '240px',
                                                                    marginLeft:'25px',
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: '#008CD7',
                                                                    },
                                                                    "& .MuiInputBase-input.Mui-disabled": {
                                                                        color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                                                                        WebkitTextFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',// Default color
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontFamily: 'Roboto',
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                    },
                                                                    '& .MuiInput-root .MuiInputBase-input': {
                                                                        
                                                                    },
                                                                    '& .MuiInputBase-root::before': {
                                                                        borderBottom: `1px solid ${themechange === 'light' ? '#C1C1C1' : '#3C3C3C'}`
                                                                    },
                                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    '& .MuiInputBase-root::after': {
                                                                        borderBottom: '2px solid #008CD7',
                                                    
                                                                    },
                                                                }}
                                                                onChange={(e) =>
                                                                    handledeviceManufacturer('commissiondate', e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ width:"100%", boxSizing:'border-box',marginRight:"10px"}}>
                                                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginTop:"10px", marginLeft:"14px",textAlign:"left"}}>Scheduled Maintenance</Typography>
                                                        <div style={{ display: 'flex', flexDirection: 'row',marginTop:"3px", alignItems:"baseline", justifyContent:"space-between" }}>
                                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"10px"}}>Last Maintenance Performed Date</Typography>
                                                            {console.log("maintenanceDetails ConfigParameters",maintenanceDetails)}
                                                            <TextField
                                                                label=""
                                                                value={maintenanceDetails?.lastmaintenanceperformeddate && maintenanceDetails?.lastmaintenanceperformeddate !== '' ? epochToIndianTimestamp(Number(maintenanceDetails?.lastmaintenanceperformeddate)) : epochToIndianTimestamp(Math.floor(Date.now() / 1000))}
                                                                disabled={true}
                                                                variant='standard'
                                                                type="string"
                                                                sx={{
                                                                    width: '240px',
                                                                    marginLeft:'25px',
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: '#008CD7',
                                                                    },
                                                                    "& .MuiInputBase-input.Mui-disabled": {
                                                                        color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                                                                        WebkitTextFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',// Default color
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontFamily: 'Roboto',
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                    },
                                                                    '& .MuiInput-root .MuiInputBase-input': {
                                                                        
                                                                    },
                                                                    '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#C1C1C1' : '#3C3C3C'}`
                                                                    },
                                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    '& .MuiInputBase-root::after': {
                                                                        borderBottom: '2px solid #008CD7',
                                                    
                                                                    },
                                                                }}
                                                                onChange={(e) =>
                                                                    handledeviceMaintenanceDetails('lastmaintenanceperformeddate', e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row',marginTop:"3px", alignItems:"baseline", justifyContent:"space-between" }}>
                                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Maintenance Interval Days</Typography>
                                                            <TextField
                                                                label=""
                                                                value={maintenanceDetails?.maintenanceintervaldays}
                                                                variant='standard'
                                                                type="number"
                                                                sx={{
                                                                    width: '240px',
                                                                    marginLeft:'25px',
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: '#008CD7',
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontFamily: 'Roboto',
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                    },
                                                                    '& .MuiInput-root .MuiInputBase-input': {
                                                                        
                                                                    },
                                                                    '& .MuiInputBase-root::before': {
                                                                        borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                                    },
                                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    '& .MuiInputBase-root::after': {
                                                                        borderBottom: '2px solid #008CD7',
                                                    
                                                                    },
                                                                }}
                                                                onBlur={handleBlurMaintenanceIntervalDays}
                                                                inputProps={{ min: 0, max: 36500 }}
                                                                helperText={errorMaintenanceIntervalDays ? `Numbers between 0 and 36500 are allowed.` : ``}
                                                                FormHelperTextProps={{
                                                                    sx : { color: errorMaintenanceIntervalDays ? '#DC272D' : '#00943D' }
                                                                }}
                                                                onChange={(e) =>
                                                                    handledeviceMaintenanceDetails('maintenanceintervaldays', e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row',marginTop:"3px", alignItems:"baseline", justifyContent:"space-between" }}>
                                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Next Maintenance Date</Typography>
                                                            <TextField
                                                                label=""
                                                                value={
                                                                    maintenanceDetails?.nextmaintenancedate && 
                                                                    maintenanceDetails?.nextmaintenancedate !== '' && 
                                                                    maintenanceDetails?.maintenanceintervaldays && 
                                                                    Number(maintenanceDetails?.maintenanceintervaldays) > 0
                                                                        ? epochToIndianTimestamp(Number(maintenanceDetails?.nextmaintenancedate)) 
                                                                        : "Not Set"
                                                                }
                                                                disabled={true}
                                                                variant='standard'
                                                                type="string"
                                                                sx={{
                                                                    width: '240px',
                                                                    marginLeft:'25px',
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: '#008CD7',
                                                                    },
                                                                    "& .MuiInputBase-input.Mui-disabled": {
                                                                        color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                                                                        WebkitTextFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',// Default color
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontFamily: 'Roboto',
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                    },
                                                                    '& .MuiInput-root .MuiInputBase-input': {
                                                                        
                                                                    },
                                                                    '& .MuiInputBase-root::before': {
                                                                    borderBottom: `1px solid ${themechange === 'light' ? '#C1C1C1' : '#3C3C3C'}`
                                                                    },
                                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    '& .MuiInputBase-root::after': {
                                                                        borderBottom: '2px solid #008CD7',
                                                    
                                                                    },
                                                                }}
                                                                onChange={(e) =>
                                                                    handledeviceMaintenanceDetails('nextmaintenancedate', e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row',marginTop:"3px", alignItems:"baseline", justifyContent:"space-between" }}>
                                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Enable Alert Before Days</Typography>
                                                            <CustomMultiSelectwithDefaultOptions
                                                                mandatory={false}
                                                                mandatoryText={"interval"}
                                                                personName={personName}
                                                                setPersonName={setPersonName}
                                                                names={['3','5','15','45']}
                                                                width={240}
                                                                selectedValues={handleEnableAlertDays}
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                            </div>
                                            <div style={{marginTop:"50px",marginLeft:"14px",}}>
                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop: '10px',}}>Note: Alert Prioriy:Highest - 3 days before actual date.</Typography> 
                                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop: '10px',}}>Note: Alert Prioriy:High - 5 days before actual date.</Typography> 
                                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop: '10px',}}>Note: Alert Prioriy:Medium - 15 days before actual date.</Typography> 
                                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop: '10px',}}>Note: Alert Prioriy:Low - 45 days before actual date.</Typography>                
                                            </div>
                                                    
                                            </>
                                        )}
                                        {console.log("devicedetailsobject[selectedType] ",devicedetailsobject[selectedType] )}
                                        {tabvalue == 'Device Condition Based Parameters' && devicedetailsobject[selectedType] && Array.isArray(devicedetailsobject[selectedType].TypeDetails) && devicedetailsobject[selectedType].TypeDetails.length > 0 &&(devicedetailsobject[selectedType].TypeDetails[0].TypeName == "_Release" || devicedetailsobject[selectedType].TypeDetails[0].TypeName == "_Relay" || devicedetailsobject[selectedType].TypeDetails[0].TypeName == "_Motor" )&& (
                                            <div style={{ width:"100%", boxSizing:'border-box',marginLeft:'10px'}}>
                                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop: '10px',}}>Default Condition Based Parameters</Typography>
                                                    <TableContainer component={Paper} sx={{width: '98.3%', marginLeft:"0px",marginRight:"0px",marginTop:"15px", paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px',height:"50%",}} className="styled-scrollbar" elevation={0}>
                                                        <Table stickyHeader  sx={{ width: '100%', }} size="large"  >
                                                            <TableHead  sx={{ width: '100%'}}>
                                                                <TableRow sx={{border:"0px",}}>
                                                                    {/* <TableCell align="left" sx={{  borderBottom: "none" , padding:"0px",paddingLeft:"10px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor: "var(--secondary-backgroundLK)",}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Enable'}/></div></TableCell> */}
                                                                    <TableCell align="left" sx={{  borderBottom: "none" ,padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor: "var(--secondary-backgroundLK)",}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Parameter'}/></div></TableCell>
                                                                    <TableCell align="left" sx={{  borderBottom: "none" ,padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor: "var(--secondary-backgroundLK)",}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Tag Name'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                                    <TableCell align="left" sx={{  borderBottom: "none" ,padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor: "var(--secondary-backgroundLK)",}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Add Tag'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                                    <TableCell align="left" sx={{  borderBottom: "none" ,padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor: "var(--secondary-backgroundLK)",}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Threshold'}/><span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></div></TableCell>
                                                                    <TableCell align="left" sx={{  borderBottom: "none" ,padding:"0px",fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor: "var(--secondary-backgroundLK)",}}><div style={{display:'flex', flexDirection:'row', alignItems:'center'}}><CustomTableHeading children={'Tag Type'}/></div></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                            {(maintenanceparameters != undefined && maintenanceparameters != null && Array.isArray(maintenanceparameters) && maintenanceparameters?.length>0) ?
                                                                    maintenanceparameters.map((maintenancecondition, index) => ( 
                                                                        <TableRow key={index} sx={{'&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" } }}>
                                                                            {/* <TableCell component="th" scope="row" sx={{  borderBottom: "none" ,padding:"0px",paddingLeft:"10px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                                                <Typography sx={{fontSize:"14px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400,textAlign:"left",marginTop:"0px"}}>Enabled</Typography>
                                                                            </TableCell> */}
                                                                            {console.log("maintenancecondition---///////////////////////////",maintenancecondition)}
                                                                            <TableCell component="th" scope="row" sx={{  borderBottom: "none" ,padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                                                <TextField
                                                                                    label=""
                                                                                    value={maintenancecondition.DefaultName}
                                                                                    variant="standard"
                                                                                    disabled
                                                                                    type="string"
                                                                                    sx={{
                                                                                        width: '140px',
                                                                                        '& .MuiInputBase-input:focus': {
                                                                                            color: '#008CD7',
                                                                                        },
                                                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                                                            color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                                                                                            WebkitTextFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',// Default color
                                                                                        },
                                                                                        '& .MuiInputBase-root': {
                                                                                            fontFamily: 'Roboto',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: '700',
                                                                                            color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                                        },
                                                                                        '& .MuiInput-root .MuiInputBase-input': {
                                                                                            
                                                                                        },
                                                                                        '& .MuiInputBase-root::before': {
                                                                                            borderBottom: `1px solid ${themechange === 'light' ? '#C1C1C1' : '#3C3C3C'}`
                                                                                        },
                                                                                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                                            borderBottom: '2px solid #008CD7',
                                                                                        },
                                                                                        '& .MuiInputBase-root::after': {
                                                                                            borderBottom: '2px solid #008CD7',
                                                                        
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell component="th" scope="row" sx={{  borderBottom: "none" ,padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                                                {console.log("maintenancecondition-maintenancecondition-maintenanceparameters",maintenancecondition)}
                                                                                {console.log("selectedAsset1--selectedAsset1",selectedAsset1,"selectedTag1---selectedTag1",selectedTag1)}
                                                                                {console.log(
                                                                                    "PeriodicMaintenanceTagID:", maintenancecondition['TagID'],
                                                                                    "tagdetailsobject[TagID]:", tagdetailsobject[maintenancecondition['TagID']],
                                                                                    "DeviceID:", tagdetailsobject[maintenancecondition['TagID']]?.DeviceID,
                                                                                    "devicedetailsobject[DeviceID]:", devicedetailsobject[tagdetailsobject[maintenancecondition['TagID']]?.DeviceID],
                                                                                    "Alias:", devicedetailsobject[tagdetailsobject[maintenancecondition['TagID']]?.DeviceID]?.Name
                                                                                    )}
                                                                                <TextField
                                                                                    label=""
                                                                                    //value={devicedetailsobject[tagdetailsobject[maintenancecondition['TagID']]?.DeviceID]?.Name || "DeviceName" +":"+ tagdetailsobject[maintenancecondition['TagID']]?.Alias || "TagAlias"}
                                                                                    value={
                                                                                        (devicedetailsobject[tagdetailsobject[maintenancecondition['TagID']]?.DeviceID]?.Name || "DeviceName") +
                                                                                        ":" +
                                                                                        (tagdetailsobject[maintenancecondition['TagID']]?.Name || "TagName")
                                                                                    }
                                                                                    variant="standard"
                                                                                    disabled
                                                                                    type="string"
                                                                                    sx={{
                                                                                        width: '140px',
                                                                                        '& .MuiInputBase-input:focus': {
                                                                                            color: '#008CD7',
                                                                                        },
                                                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                                                            color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                                                                                            WebkitTextFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',// Default color
                                                                                        },
                                                                                        '& .MuiInputBase-root': {
                                                                                            fontFamily: 'Roboto',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: '700',
                                                                                            color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                                        },
                                                                                        '& .MuiInput-root .MuiInputBase-input': {
                                                                                            
                                                                                        },
                                                                                        '& .MuiInputBase-root::before': {
                                                                                            borderBottom: `1px solid ${themechange === 'light' ? '#C1C1C1' : '#3C3C3C'}`
                                                                                        },
                                                                                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                                            borderBottom: '2px solid #008CD7',
                                                                                        },
                                                                                        '& .MuiInputBase-root::after': {
                                                                                            borderBottom: '2px solid #008CD7',
                                                                        
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell component="th" scope="row" sx={{  borderBottom: "none" ,padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                                                <CustomActionButton buttonText={'Add Tag'} onClick={(e) => handleAddTagselectionMaintenanceParameter(index)} />
                                                                            </TableCell>
                                                                            <TableCell component="th" scope="row" sx={{  borderBottom: "none",padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                                                {console.log("maintenancecondition///-----=======",maintenancecondition)}
                                                                                <TextField
                                                                                    label=""
                                                                                    value={maintenancecondition.Threshold}
                                                                                    variant="standard"
                                                                                    type="number"
                                                                                    onChange={(e) =>
                                                                                        handlePredfinedMaintenanceParametersSelectionAddTag(index, 'Threshold', e.target.value)
                                                                                    }
                                                                                    inputProps={{ min: 0, max: 1000000 }}
                                                                                    helperText={(errorPredefinedMaintenanceDefaultConditions[index]==true) ? `Numbers between 0 and 1000000 are allowed.` : ``}
                                                                                    FormHelperTextProps={{
                                                                                        sx : { color: (errorPredefinedMaintenanceDefaultConditions[index]==true) ? '#DC272D' : '#00943D' }
                                                                                    }}
                                                                                    sx={{
                                                                                        width: '94px',
                                                                                        borderBottom: "none" ,
                                                                                        '& .MuiInputBase-input:focus': {
                                                                                            color: '#008CD7',
                                                                                        },
                                                                                        '& .MuiInputBase-root': {
                                                                                            fontFamily: 'Roboto',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: '700',
                                                                                            color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                                                        },
                                                                                        '& .MuiInput-root .MuiInputBase-input': {
                                                                                            
                                                                                        },
                                                                                        '& .MuiInputBase-root::before': {
                                                                                            borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                                                        },
                                                                                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                                            borderBottom: '2px solid #008CD7',
                                                                                        },
                                                                                        '& .MuiInputBase-root::after': {
                                                                                            borderBottom: '2px solid #008CD7',
                                                                        
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell component="th" scope="row" sx={{  borderBottom: "none",padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                                                <CustomDropDown options={mapTypes[maintenancecondition.DefaultName]} onChange={(value) => handlePredfinedMaintenanceParametersSelectionAddTag(index, 'TagType', value)} /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={maintenancecondition.TagType || "state"}></CustomDropDown>
                                                                            </TableCell>
                                                                            <TableCell component="th" scope="row" sx={{  borderBottom: "none",padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}>
                                                                                
                                                                            </TableCell>
                                                                    </TableRow>
                                                                    )):null}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    
                                                    <Dialog 
                                                        open={tagselection} 
                                                        onClose={handleTagSelectionClose}
                                                        BackdropProps={{
                                                            sx:{
                                                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                                            }
                                                        }}
                                                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                                                            <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{"Confirm Save Action"}</DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                                                    <div>
                                                                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Selected Parameter Tagname:{selectedAsset.asset_name+": "+selectedTag.tagname + "    "+selectedTag.tagunit}<span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></Typography>
                                                                        <div>
                                                                            <AssetTagsRetrievalModified assetdata={assetdata} setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} setSelectedTag={setSelectedTag} setSelectedAsset={setSelectedAsset} />
                                                                        </div>
                                                                    </div>
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions sx={{justifyContent:'center'}}>
                                                                <Button onClick={(e) => handleConditionChange(tagindex, 'TagID', e.target.value)} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                                                    Confirm
                                                                </Button>
                                                                <CustomCancelButton onClick={handleTagSelectionClose} buttonText={'Cancel'}></CustomCancelButton>
                                                            </DialogActions>
                                                    </Dialog> 
                                                    <Dialog 
                                                        open={tagselectionMaintenanceParameter} 
                                                        onClose={handleAddTagselectionMaintenanceParameterClose}
                                                        BackdropProps={{
                                                            sx:{
                                                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                                            }
                                                        }}
                                                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                                                            <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{"Confirm Save Action"}</DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                                                    <div>
                                                                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Selected Parameter Tagname:{selectedAsset.asset_name+": "+selectedTag.tagname + "    "+selectedTag.tagunit}<span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></Typography>
                                                                        <div>
                                                                            <AssetTagsRetrievalModified assetdata={assetdata} setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} setSelectedTag={setSelectedTag1} setSelectedAsset={setSelectedAsset1} />
                                                                        </div>
                                                                    </div>
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions sx={{justifyContent:'center'}}>
                                                                <Button onClick={(e) => handlePredfinedMaintenanceParametersSelectionAddTag(tagindexMaintenanceParameter, 'TagID', e.target.value)} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                                                    Confirm
                                                                </Button>
                                                                <CustomCancelButton onClick={handleAddTagselectionMaintenanceParameterClose} buttonText={'Cancel'}></CustomCancelButton>
                                                            </DialogActions>
                                                    </Dialog>  
                                                    
                                            </div>)}
                                        {tabvalue == 'Creation of SOP Template for Maintenance Tasks' && (
                                            <div style={{ width:"100%",}}>
                                                {console.log("Questionnaire-",Questionnaire,"template",template)}
                                                <Questionnaire onSubmitTemplate={handleSubmitTemplate} selectedType={selectedType} template={template} clickedHandleSubmit={clickedHandleSubmit} setClickedHandleSubmit={setClickedHandleSubmit}/>
                                            </div>
                                        )}
                                        {tabvalue == 'Assign Maintenance Tasks' && (
                                            <div style={{ width:"100%",}}>
                                                <div style={{display:"flex", flexDirection:"row", alignItems:"baseline"}}>
                                                    <div>
                                                        <Typography sx={{fontSize:"16px", marginTop: '10px',fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"10px",textAlign:"left"}}>Create Maintenance Task</Typography></div>
                                                    <div style={{flex:1}}></div>
                                                    <div>
                                                        <Button sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'270px',fontSize: '16px',textTransform:'capitalize', marginTop:"10px",marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" onClick={handleSubmitMaintenanceTask}>
                                                            Add Maintenance Task To Save
                                                        </Button>
                                                    </div>
                                                </div>
                                                
                                                <div style={{ display: 'flex', flexDirection: 'row',marginTop:"8px", alignItems:"baseline"}}>
                                                    <Typography sx={{fontSize:"16px", marginTop: '10px',fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"10px",textAlign:"left"}}>Assigned By:</Typography>   
                                                    <Typography sx={{fontSize:"16px", marginTop: '10px',fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"10px",textAlign:"left"}}>{userdetails.Email}</Typography> 
                                                    
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'row',marginTop:"0px", alignItems:"baseline",gap:"10px"}}>
                                                    <Typography sx={{fontSize:"16px", marginTop: '0px',fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"10px",textAlign:"left"}}>Assigned To:</Typography>   
                                                    <CustomMultiSelectwithDefaultOptions
                                                                    mandatory={true}
                                                                    mandatoryText={"person"}
                                                                    personName={personName1}
                                                                    setPersonName={setPersonName1}
                                                                    names={overallMaintenanceUsersEmailID}
                                                                    width={235}
                                                                    selectedValues={handleAssignOverallMaintenanceUsersEmailID}
                                                                />
                                                    
                                                    
                                                </div>
                                                <Dialog 
                                                    open={usersformaintenancesubmitted} 
                                                    onClose={handleCloseUsersForMaintenanceSubmitted}
                                                    BackdropProps={{
                                                        sx:{
                                                            backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                                        }
                                                    }}
                                                    sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                                                        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{"Added to Save"}</DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                                                Added Assigned Users of Maintenance Tasks for saving
                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions sx={{justifyContent:'center'}}>
                                                            <CustomCancelButton onClick={handleCloseUsersForMaintenanceSubmitted} buttonText={'Ok'}></CustomCancelButton>
                                                        </DialogActions>
                                                </Dialog>
                                            </div>
                                            
                                        )}
                                </Box>
                            </Box>
                        </div>  
                </div>
                    <Dialog
                        open={openDashboardDialog}
                        onClose={handleCloseConfigureDashboard}
                        fullWidth
                        maxWidth="xl"
                        BackdropProps={{
                            sx: {
                                backgroundColor: themechange === 'light' ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.3)',
                            },
                        }}
                        sx={{
                            "& .MuiDialog-paper": {
                                height: "30vh",
                                width: "50%",
                                borderTopLeftRadius: "40px",
                                borderTopRightRadius: "40px",
                                overflow: "auto",
                                backgroundColor: themechange === 'light' ? "#FFFFFF" : "#19191B",
                            },
                        }}
                    >
                        <DialogTitle
                            sx={{
                                color: "#FFFFFF",
                                backgroundColor: "#005C8E",
                                margin: "5px",
                                borderRadius: "100px",
                            }}
                        >
                            Configure Dashboard
                        </DialogTitle>
                        <DialogContent
                            sx={{
                                width: "98%",
                                height: "100%",
                                backgroundColor: 'var(--secondary-backgroundLK)',
                                overflow: "auto",
                                position: "relative",
                            }}
                        >
                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop:"10px"}}>{"Please click on Create to configure Asset Maintenance dashboards"}</Typography>
                            <div style={{ width:"100%",display: 'flex', flexDirection: 'row', gap:"30px",marginTop:"20px" }}>
                                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop:"10px"}}>{"Enter dashboard name"}</Typography>
                                <TextField
                                    label=""
                                    value={dashboardName}
                                    variant="standard"
                                    onChange={(e) => handledashboardNameChange(e.target.value)}
                                    required
                                    inputProps={{ minLength: 5, maxLength: 30 }}
                                    helperText={
                                        dashboardName.length > 0 &&
                                        (!isValidLength(dashboardName, 5, 30) || containsSpacesOrSpecialChars(dashboardName))
                                        ? `Length must be between 5 and 30 characters. Only letters, numbers, spaces, and underscores are allowed. ${dashboardName.length}/30 characters used`
                                        : `${dashboardName.length}/30 characters used`
                                    }
                                    FormHelperTextProps={{
                                        sx: {
                                        color: (dashboardName.length > 0 && (!isValidLength(dashboardName, 5, 30) || containsSpacesOrSpecialChars(dashboardName)))
                                            ? '#DC272D'
                                            : '#00943D'
                                        }
                                    }}
                                    sx={{
                                        width: '50%',
                                        '& .MuiInputBase-input:focus': {
                                        color: '#008CD7',
                                        },
                                        '& .MuiInputBase-root': {
                                        fontFamily: 'Roboto',
                                        fontSize: '16px',
                                        fontWeight: '700',
                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                        },
                                        '& .MuiInput-root .MuiInputBase-input': {},
                                        '& .MuiInputBase-root::before': {
                                        borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                        },
                                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                        borderBottom: '2px solid #008CD7',
                                        },
                                        '& .MuiInputBase-root::after': {
                                        borderBottom: '2px solid #008CD7',
                                        },
                                    }}
                                    />
                            </div>
                            
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'center' }}>
                            <Button
                                onClick={handleSaveConfiguredDashboard}
                                sx={{
                                    outline: 'none !important',
                                    boxShadow: 'none',
                                    height: '35px',
                                    width: '125px',
                                    fontSize: '16px',
                                    textTransform: 'capitalize',
                                    marginRight: '5px',
                                    backgroundColor: '#005C8E',
                                    borderRadius: '20px',
                                }}
                                variant="contained"
                                autoFocus
                            >
                                Create
                            </Button>
                            <CustomCancelButton onClick={handleCloseConfigureDashboard} buttonText={'Cancel'} />
                        </DialogActions>
                    </Dialog>
                <Dialog 
                    open={confirmSaveChangesDialog} 
                    onClose={handleconfirmSaveChangesDialogClose}
                    BackdropProps={{
                        sx:{
                            backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                        }
                    }}
                    sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{"Confirm Save Changes"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                <div>
                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Are you sure to save changes? </Typography>
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{justifyContent:'center'}}>
                            <Button onClick={(e) => handleconfirmSaveChangesDialogSave(tagindexMaintenanceParameter, 'TagID', e.target.value)} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                Confirm
                            </Button>
                            <CustomCancelButton onClick={handleconfirmSaveChangesDialogClose} buttonText={'Cancel'}></CustomCancelButton>
                        </DialogActions>
                </Dialog> 
                <CustomDialogBox dialogTitle={"Selection of Device"} dialogText={"Please select a Device"} openDialog={opennotselectedType} handleCloseDialog={handleopennotselectedTypeClose} handleConfirmDialog={handleopennotselectedTypeClose} confirmText={"Ok"} cancelText={"Cancel"} />
                <CustomDialogBox dialogTitle={"Selection of Condition Based Parameters"} dialogText={"Please enter proper condition based parameters and thresholds"} openDialog={openconditionBasedParameters} handleCloseDialog={handleopenconditionBasedParametersClose} handleConfirmDialog={handleopenconditionBasedParametersClose} confirmText={"Ok"} cancelText={"Cancel"} />
                <CustomDialogBox dialogTitle={"Default Condition Based Maintenance Parameters"} dialogText={"Please go to the Tab 'Device Condition Based Maintenance Parameters' and select proper default condition based parameters and thresholds"} openDialog={opendefaultParameters} handleCloseDialog={handleopendefaultParametersClose} handleConfirmDialog={handleopendefaultParametersClose} confirmText={"Ok"} cancelText={"Cancel"} />
                <CustomDialogBox dialogTitle={"Selection of assignment for tasks"} dialogText={"Please enter proper assignment for tasks and click on Submit SOP QnA Template"} openDialog={openuserdetailsemail} handleCloseDialog={handleopenuserdetailsemailClose} handleConfirmDialog={handleopenuserdetailsemailClose} confirmText={"Ok"} cancelText={"Cancel"} />
                <CustomDialogBox dialogTitle={"Assignment of Maintenance Tasks"} dialogText={"Please go to the Tab 'Assign Maintenance Tasks' and assign users for maintenance tasks.Click on 'Add Maintenance Task To Save' button."} openDialog={openoverallAssignedMaintenanceUsersObtained} handleCloseDialog={handleopenoverallAssignedMaintenanceUsersObtainedClose} handleConfirmDialog={handleopenoverallAssignedMaintenanceUsersObtainedClose} confirmText={"Ok"} cancelText={"Cancel"} />
                <CustomDialogBox dialogTitle={"Creation of SOP Template"} dialogText={"Please go to the Tab 'Creation of SOP Template for Maintenance Tasks' and create scheduled maintenance tasks SOP template or keep default question and Click on 'Add SOP Template To Save' button"} openDialog={questionstemplateempty} handleCloseDialog={handlequestionstemplateemptyOk} handleConfirmDialog={handlequestionstemplateemptyOk} confirmText={"Ok"} cancelText={"Cancel"} />
                <CustomDialogBox dialogTitle={"Configuration Saved Status"} dialogText={(configurationSavedSuccessfully==true)?"Configuration Saved Successfully":configurationSavedMessage || "Failed to Save Configuration, Try Again"} openDialog={openDialogconfigurationSavedSuccessfully} handleCloseDialog={handlesetopenDialogConfigurationSavedSuccessfullyClose} handleConfirmDialog={handlesetopenDialogConfigurationSavedSuccessfullyClose} confirmText={"Ok"} cancelText={"Cancel"} type={(configurationSavedSuccessfully==true)?"Success":"Error"}/>
                <CustomDialogBox dialogTitle={"Created Dashboard Successfully"} dialogText={"Dashboard Successfully created "}  openDialog={createdSucess}  handleCloseDialog={handleCloseCreateDashboard}  handleConfirmDialog={handleCloseCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
                <CustomDialogBox dialogTitle={"Created Dashboard Failed"} dialogText={notCreatedMessage || "Failed to create dashboard .Try Again! "}  openDialog={notCreatedSuccess}  handleCloseDialog={handleCloseNotCreateDashboard}  handleConfirmDialog={handleCloseNotCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
                <CustomDialogBox dialogTitle={"Creation of Dashboard Failed"} dialogText={"Check if Dashboard Name has length between 5-30 characters and no special characters"}  openDialog={openAlertRuleNameExceedsLength}  handleCloseDialog={handleAlertRuleNameExceedsLength}  handleConfirmDialog={handleAlertRuleNameExceedsLength}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
                 {/* Dialog for condition limit */}
                <CustomDialogBox
                    dialogTitle={"Selection of Condition Based Parameters"}
                    dialogText={"You cannot add more than 10 condition based parameters."}
                    openDialog={openConditionLimitDialog}
                    handleCloseDialog={handleOpenConditionLimitDialogClose}
                    handleConfirmDialog={handleOpenConditionLimitDialogClose}
                    confirmText={"Ok"}
                    cancelText={"Cancel"}
                />
                <CustomDialogBox
                    dialogTitle={"Length of Question Description"}
                    dialogText={"Length of Question Description should be  greater than 5 and less than 30"}
                    openDialog={errorQuestionLength}
                    handleCloseDialog={handleErrorQuestionLength}
                    handleConfirmDialog={handleErrorQuestionLength}
                    confirmText={"Ok"}
                    cancelText={"Cancel"}
                />
                <CustomDialogBox
                    dialogTitle={"Length of Options Description"}
                    dialogText={"Length of Options Description should be  greater than 5 and less than 30"}
                    openDialog={errorOptionLength}
                    handleCloseDialog={handleErrorOptionLength}
                    handleConfirmDialog={handleErrorOptionLength}
                    confirmText={"Ok"}
                    cancelText={"Cancel"}
                />
            </Box>}
            {(viewDashboard == true) && 
                <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box", width:"100%" }}>
                    <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
                        <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                            <Box sx={{flexGrow:1}}></Box>
                            <CustomCancelButton onClick={handleCancelViewDashboard} buttonText={'Cancel'}></CustomCancelButton>
                        </Box>
                        <PeriodicMaintenanceStandardDashboards />
                    </Box>
                </Box>}
        </>
        
    );
    
}

{/*
    
    {conditions.map((condition, index) => (
                            <div>
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left"}}>Parameter Tag Name</Typography>
                                    <TextField
                                        label=""
                                        value={condition.parametername}
                                        variant="standard"
                                        type="string"
                                        sx={{
                                            width: '94px',
                                            '& .MuiInputBase-input:focus': {
                                                color: '#008CD7',
                                            },
                                            '& .MuiInputBase-root': {
                                                fontFamily: 'Roboto',
                                                fontSize: '16px',
                                                fontWeight: '700',
                                                color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                            },
                                            '& .MuiInput-root .MuiInputBase-input': {
                                                
                                            },
                                            '& .MuiInputBase-root::before': {
                                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: '2px solid #008CD7',
                                            },
                                            '& .MuiInputBase-root::after': {
                                                borderBottom: '2px solid #008CD7',
                            
                                            },
                                        }}
                                    />
                                    <div style={{display:"flex", marginTop:"10px", paddingTop:0}}>
                                        <CustomActionButton buttonText={'Add Tag'} onClick={(e) => handleAddTag(index)} />
                                    </div>
                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"10px"}}>Enter Parameter Threshold</Typography>
                                    <TextField
                                        label=""
                                        value={condition.Threshold_upper}
                                        variant="standard"
                                        type="number"
                                        onChange={(e) =>
                                            handleConditionChange(index, 'Threshold_upper', e.target.value)
                                        }
                                        sx={{
                                            width: '94px',
                                            '& .MuiInputBase-input:focus': {
                                                color: '#008CD7',
                                            },
                                            '& .MuiInputBase-root': {
                                                fontFamily: 'Roboto',
                                                fontSize: '16px',
                                                fontWeight: '700',
                                                color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                            },
                                            '& .MuiInput-root .MuiInputBase-input': {
                                                
                                            },
                                            '& .MuiInputBase-root::before': {
                                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: '2px solid #008CD7',
                                            },
                                            '& .MuiInputBase-root::after': {
                                                borderBottom: '2px solid #008CD7',
                            
                                            },
                                        }}
                                    />

                                    <Typography sx={{ display: 'flex', alignItems: 'left',whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis" }}>
                                        <Checkbox checkedIcon={<CheckBoxOutlinedIcon />}  style={{color:'var(--SecondaryText)', color:"008CD7"}}
                                            checked={(condition.Enable == true)}
                                            sx={{
                                                padding: 0,
                                                margin: 0,
                                                color: 'var(--HighlightedText_Stroke)',
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: '20px',
                                                    color: 'var(--HighlightedText_Stroke)'
                                                }
                                            }}
                                            onChange={(event) => handleConditionChange(index, 'Enable', condition.Enable)}
                                        />
                                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"10px"}}>Enable for CB Maintenance</Typography>
                                    </Typography>
                                    <Button sx={{ width:"20px",height:"20px",padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none"}} variant="text" onClick={() => handleRemoveRow(index)} disableTouchRipple elevation={0}><LK_Delete color={"#005C8E"} width={"20px"} height={"20px"}/></Button>
                                    {<div style={{display:"flex", marginTop:0, paddingTop:0}}>
                                        <CustomActionButton buttonText={'Add Row'} onClick={handleAddRow} />
                                    </div>}

                                    <Dialog 
                                        open={tagselection} 
                                        onClose={handleTagSelectionClose}
                                        BackdropProps={{
                                            sx:{
                                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                            }
                                        }}
                                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                                            <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{"Confirm Save Action"}</DialogTitle>
                                            <DialogContent>
                                                <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                                    <div>
                                                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Selected Parameter Tagname:{selectedAsset.asset_name+": "+selectedTag.tagname + "    "+selectedTag.tagunit}<span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></Typography>
                                                        <div>
                                                            <AssetTagsRetrievalModified assetdata={assetdata} setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} setSelectedTag={setSelectedTag} setSelectedAsset={setSelectedAsset} />
                                                        </div>
                                                    </div>
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions sx={{justifyContent:'center'}}>
                                                <Button onClick={(e) => handleConditionChange(tagindex, 'TagID', e.target.value)} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                                    Confirm
                                                </Button>
                                                <CustomCancelButton onClick={handleTagSelectionClose} buttonText={'Cancel'}></CustomCancelButton>
                                            </DialogActions>
                                    </Dialog>          
                                </div>
                            </div>
                        ))}
                            
                        */}